import { createI18n, type I18nOptions } from "vue-i18n";

import {
    getSessionSettings,
    setSessionSettings,
    type SupportedLocale
} from "@ja/portal-query";

import sharedEn from "./locales/shared/en.json";
import sharedFr from "./locales/shared/fr.json";

export type { SupportedLocale };

/**
 * Get browser locale, defaulting to French if unavailable.
 * Checks localStorage first for persistence.
 */
export function getPortalLocale(): SupportedLocale {
    return getSessionSettings().locale;
}

/**
 * Set the portal locale and persist to localStorage and cookie.
 * Cookie is used by server-side HandleSessionSettingsMiddleware.
 */
export function setPortalLocale(locale: string): void {
    if (locale === "en" || locale === "fr") {
        void setSessionSettings({ locale: locale as SupportedLocale });
    }
}

/**
 * Create a vue-i18n instance with portal defaults.
 * Automatically merges shared translations with provided messages.
 */
export function createPortalI18n(options: Partial<I18nOptions> = {}) {
    const defaultLocale = getPortalLocale();

    const messages = options.messages || { en: {}, fr: {} };

    // Merge shared messages
    const mergedMessages = {
        en: { ...sharedEn, ...((messages.en as object) || {}) },
        fr: { ...sharedFr, ...((messages.fr as object) || {}) }
    };

    return createI18n({
        legacy: false,
        locale: defaultLocale,
        fallbackLocale: "en",
        ...options,
        messages: mergedMessages
    });
}
